import { useQuery } from 'react-query';
import request from '../../../../../helpers/request';

const createKey = () => ['massActionsRequestStatuses'];

const fetch = () =>
  request.get(
    `/Request/statuses_for_set`,
    {},
    `Произошла ошибка при загрузке статусов`,
    'Error'
  );

const useFetch = (options) => useQuery(createKey(), fetch, options);

const queryData = { createKey, useFetch };

export default queryData;
